import { motion } from 'framer-motion';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ResourceSubmissionTypeSelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  padding: 16px 10px;

  border-radius: 8px;
  background: rgba(173, 173, 173, 0.08);

  ${({ theme }) =>
    theme.isError &&
    `
    padding: 15px 9px;
    border: 1px solid var(--color-error);
  `}

  cursor: pointer;
  position: relative;
`;

export const ResourceSubmissionTypeSelectCurrentOption = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  ${BREAKPOINTS.tablet} {
    font-size: 18px;
  }

  color: var(--color-text);
`;

export const ResourceSubmissionTypeSelectPlaceholder = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: rgba(23, 28, 51, 0.5);
`;

export const ResourceSubmissionTypeSelectOptionsContainer = styled(motion.div).attrs({
  animate: { maxHeight: 200 },
  initial: { maxHeight: 0 },
  exit: { maxHeight: 0 },
})`
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;

  border-radius: 0px 0px 8px 8px;

  background: #ffffff;

  transform: translateY(calc(100% - 4px));

  overflow: auto;
  z-index: 2;

  & > :last-child {
    padding-bottom: 19px;
  }
`;

export const ResourceSubmissionTypeSelectOptionContainer = styled.div`
  padding: 3px 24px 3px 18px;

  &:hover {
    background: #f5f5f5;
  }
`;

export const ResourceSubmissionTypeSelectOptionLabel = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: normal;

  color: var(--color-text);
`;
